import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Page from 'components/Page';
import { Card, CardBody, CardFooter, Col, Container, Row, Modal, ModalBody, ModalHeader, Label, Input } from 'reactstrap';
import { BsFillJournalBookmarkFill, BsListOl, BsThreeDotsVertical, BsFillGearFill, BsJournalText } from 'react-icons/bs';
import { GoDeviceDesktop } from 'react-icons/go';
import { MdOutlineFileUpload } from 'react-icons/md';
import { IoHome } from 'react-icons/io5';
import { useCookies } from 'react-cookie';
import { FaMedal, FaUsers, FaArrowLeft, FaPlus, FaIndustry } from 'react-icons/fa';
import { BiCategoryAlt } from 'react-icons/bi';
import { ImEnter, ImHammer2 } from 'react-icons/im';
import PageSpinner from 'components/PageSpinner';
import Logo from 'assets/img/icon.png';
import CustomToast from 'utils/CustomToast';
import axios from 'axios';
import { id } from 'date-fns/locale';
import AdminAwardTypeMenu from '../components/AdminAwardTypeMenu';

const initialData = Object.freeze({
  name: '',
  logo: '',
  year: ''
});

const initialSettingsData = Object.freeze({
  name: '',
  country: '',
  smtp_code: ''
});

const initialAwardTypeData = Object.freeze({
  id: 0,
  name: 'Awards',
  created_at: ''
})

const AdminAwardTypePastAwardsPage = () => {
  const location = useLocation();
  const history = useHistory();
  const currentPathName = location.pathname;
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();
  const awardTypeId = query.get('id');

  const [awardTypeData, setAwardTypeData] = useState(initialAwardTypeData);
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const [settingsModal, setSettingsModal] = useState(false);
  const [settingsFormData, setSettingsFormData] = useState(initialSettingsData);

  const [addModal, setAddModal] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [imagePreview, setImagePreview] = useState('');

  const [formStatus, setFormStatus] = useState('standby');

  const hiddenFileInputFile = useRef(null);

  const [upcomingAwards, setUpcomingAwards] = useState([]);
  const [previousSponsors, setPreviousSponsors] = useState([]);
  const [sponsorIds, setSponsorIds] = useState([]);

  const [awardCount, setAwardCount] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [reloadCount, setReloadCount] = useState(0);
  const [upcomingAwardsLoading, setUpcomingAwardsLoading] = useState(true);
  const cookies = useCookies(['currentUser', 'isLoggedIn', 'userRole', 'token', 'section', 'userDetails']);
  const currentUser = cookies[0].currentUser;
  const token = cookies[0].token;

  const tokenIdCombo = {
    user_id: currentUser,
    token: token
  }
  const { admin_privileges, award_settings } = cookies[0].userDetails.user;

  const getAwards = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + 'award', {
      params: {
        ...tokenIdCombo,
        award_type_id: awardTypeId,
        order: 'desc'
      },
    });
  }

  const getAwardsPrevSponsors = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + 'award/type/' + awardTypeId + '/previous/sponsor', {
      params: {
        ...tokenIdCombo
      },
    });
  }

  const postEvent = (data) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + 'event', data, {
      params: {
        ...tokenIdCombo
      },
    });
  }

  const postEventLogoUpload = (data) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + 'event/image/upload', data, {
      params: {
        ...tokenIdCombo
      },
    });
  }

  const getAwardTypeById = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + 'award-type/' + awardTypeId, {
      params: {
        ...tokenIdCombo,
        award_type_id: awardTypeId
      },
    });
  }

  const putAwardTypeById = (data) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + 'award-type/' + awardTypeId, data, {
      params: {
        ...tokenIdCombo
      },
    });
  }

  const getUsers = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + 'user/count', {
      params: tokenIdCombo
    })
  }

  const toggleSettings = () => {
    setSettingsFormData(prev => (
      {
        ...prev,
        name: awardTypeData.name,
        country: awardTypeData.country,
        smtp_code: awardTypeData.smtp_code
      }
    ));
    setSettingsModal(true);
  }

  const handleClickFile = () => {
    hiddenFileInputFile.current.click();
  };

  const handleDragEnter = e => {
    e.preventDefault();
  };

  const handleDragOver = e => {
    e.preventDefault();
  };

  const handleDragLeave = e => {
    e.preventDefault();
  };

  const handleDrop = e => {
    e.preventDefault();

    const droppedFiles = e.dataTransfer.files;
    const totalFilesCount = droppedFiles.length;

    if (totalFilesCount > 1) {
      const message = "This field accepts only 1 image!";
      CustomToast.warning(message);
      return;
    }

    if (!droppedFiles[0].type.includes('image')) {
      const message = "This field accepts only 1 image!";
      CustomToast.warning(message);
      return;
    }

    if (formStatus === 'loading')
      return;

    setFormStatus('loading');

    const payload = new FormData;
    payload.append('url', droppedFiles[0]);

    postEventLogoUpload(payload).then(response => {
      const status = response.data.status;

      if (status === 'Success') {
        const data = response.data.data;
        setImagePreview(data.url)

        setFormData(prev => ({
          ...prev,
          logo: data.url
        }));
        setFormStatus('standby');
      } else {
        setFormStatus('standby');
        CustomToast.defaultWarning();
      }
    }).catch(() => {
      setFormStatus('standby');
      CustomToast.defaultError();
    });
  };

  const handleChangeSettings = (e) => {
    const { name, value } = e.target;
    setSettingsFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name !== 'logo') {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      if (files.length > 1) {
        const message = "This field accepts only 1 image!";
        CustomToast.warning(message);
        return;
      }
      setFormStatus('loading');

      const payload = new FormData;
      payload.append('url', files[0]);

      postEventLogoUpload(payload).then(response => {
        const status = response.data.status;

        if (status === 'Success') {
          const data = response.data.data;
          setImagePreview(data.url)

          setFormData(prev => ({
            ...prev,
            logo: data.url
          }));
          setFormStatus('standby');
        } else {
          setFormStatus('standby');
          CustomToast.defaultWarning();
        }
      }).catch(() => {
        setFormStatus('standby');
        CustomToast.defaultError();
      });
    }
  }

  const handleCheckboxChange = (id) => {
      const index = sponsorIds.indexOf(id);
      
      if (index === -1) {
          setSponsorIds([...sponsorIds, id]);
      } else {
          const updatedSponsorIds = [...sponsorIds];
          updatedSponsorIds.splice(index, 1);
          setSponsorIds(updatedSponsorIds);
      }
  };

  const submitAward = () => {
    if (!settingsFormData.name || !settingsFormData.country) {
      const message = 'Please fill up the required fields!';
      setFormStatus('standby');
      CustomToast.warning(message);
      return;
    }

    setFormStatus('loading');
    putAwardTypeById(settingsFormData).then(response => {
      const { status } = response.data;

      if (status === 'Success') {
        setSettingsFormData(initialSettingsData);
        setFormStatus('standby');
        setReloadCount(count => count + 1);
        setSettingsModal(false);
        CustomToast.success('Award type updated successfully!');
      } else {
        setFormStatus('standby');
        CustomToast.defaultWarning();
      }
    }).catch(() => {
        setFormStatus('standby');
        CustomToast.defaultError();
    });
  }

  const submitEvent = () => {
    if (!formData.name || !formData.year || !formData.logo) {
      const message = 'Please fill up the required fields!';
      setFormStatus('standby');
      CustomToast.warning(message);
      return;
    }

    setFormStatus('loading');

    const payload = {
      award_type_id: awardTypeId,
      sponsorship_agreement_ids: sponsorIds,
      ...formData
    };
    postEvent(payload).then(response => {
      const { status } = response.data;

      if (status === 'Success') {
        setImagePreview('');
        setFormData(initialData);
        setFormStatus('standby');
        setReloadCount(count => count + 1);
        setAddModal(false);
      } else {
        setFormStatus('standby');
        CustomToast.defaultWarning();
      }
    }).catch(() => {
        setFormStatus('standby');
        CustomToast.defaultError();
    });
  }

  useEffect(() => {

    getAwards().then(response => {
      const selectedUpcomingAwards = response.data.data;
      if (selectedUpcomingAwards) {
        if (response.data.breadcrumbs) {
          setBreadcrumbs(response.data.breadcrumbs);
        }
        setUpcomingAwards(selectedUpcomingAwards);
        setUpcomingAwardsLoading(false);
        setAwardCount(selectedUpcomingAwards.length);
      } else {
        setUpcomingAwards([]);
        setUpcomingAwardsLoading(false);
        setAwardCount(0);
      }
    }).catch(() => CustomToast.defaultError());

    getAwardTypeById().then(response => {
      const result = response.data.data;
      if (result) {
        setAwardTypeData(result);
      } else {
        CustomToast.defaultWarning();
      }
    }).catch(() => CustomToast.defaultError());

    getUsers().then(response => {
      const { users_count } = response.data.data
      if (users_count) {
        setUserCount(users_count);
      } else {
        CustomToast.defaultWarning();
      }
    }).catch(() => CustomToast.defaultError());

    getAwardsPrevSponsors().then(response => {
      const prevSponsors = response.data.data;
      if (prevSponsors) {
        setPreviousSponsors(prevSponsors);
      } else {
        CustomToast.defaultWarning();
      }
    }).catch(() => CustomToast.defaultError())
  }, [reloadCount]);

  return (
    <Page
      className="preview"
      title=""
      breadcrumbs={[{ name: 'Admin Dashboard', active: true }]}
    >
      <Container>
        {!currentUser ?
          <PageSpinner />
          :
          <Row className="award_preview my-5">
            <Col lg="3">
              <Card className="text-center award-sidebar mb-3">
                <CardBody>
                  <img src={Logo} alt="Business River" className="bis-sidebar-icon"/>
                </CardBody>
              </Card>
              <AdminAwardTypeMenu page="PAST AWARDS" id={awardTypeId} />
              <Card className="mb-3">
                <CardBody>
                  <Row className="icons_row">
                    <Col lg="5" className="mb-0">
                      <FaMedal className="book_svg_single" />
                    </Col>
                    <Col lg="7" className="mb-1">
                      <p className="award-subheader text-center mb-2">EVENTS</p>
                      <p className="profile_number text-center mb-0">{awardCount}</p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row className="icons_row">
                    <Col lg="5" className="mb-0">
                      <FaUsers className="book_svg_single" />
                    </Col>
                    <Col lg="7" className="mb-0">
                      <p className="award-subheader text-center mb-2">USERS</p>
                      <p className="profile_number text-center mb-0">{userCount}</p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg="9">
              <Row>
                <Col lg='12'>
                  <h2 className="award-header">Past Awards</h2>
                  <div className="divider mb-2"></div>
                  <p>
                    {breadcrumbs.map(({name, link}, index) => (
                      <span>
                        <a href={link}>{name}</a> {(index + 1) < breadcrumbs.length ? ' > ' : ''}
                      </span>
                    ))}
                    {' > '}<a href={`/admin/award-type/past-awards?id=${awardTypeId}`}>Past Awards</a>
                  </p>
                </Col>
                {/* <Col lg='4' className='text-right'>
                  <div class='bis-tooltip mr-2' onClick={() => setAddModal(true)}>
                    <FaPlus className='text-black edit-icon' /><span class='bis-tooltiptext'>NEW</span>
                  </div>
                  {award_settings == 1 &&
                    <div className="bis-tooltip mr-1" onClick={toggleSettings}><BsFillGearFill className="text-black edit-icon" />
                      <span className="bis-tooltiptext">SETTINGS</span>
                    </div>
                  }
                  <div class='bis-tooltip' onClick={() => history.goBack()}>
                    <FaArrowLeft className='text-black edit-icon' /><span class='bis-tooltiptext'>BACK</span>
                  </div>
                </Col> */}
              </Row>
              <h3 className="award-subheader">EVENTS</h3>
              <Card className="preview_content mb-3">
                <CardBody>
                  <table className="text-left table table-hover">
                    <thead className="admin_award_table">
                      <tr>
                        <th></th>
                        <th>NAME</th>
                        <th className="text-center">ACTIONS</th>
                      </tr>
                      {!upcomingAwardsLoading ?
                        <>
                          {upcomingAwards.length > 0 ?
                            <>
                              {upcomingAwards.map(({ name, category_count, entry_deadline, booking_count, entries, judging_status, judging_begins, judging_deadline, shortlisting_status, shortlisting_begins, shortlisting_deadline, logo, id, booking_status }, index) => (
                                <>
                                {index != 0 && (
                                  <tr key={index}>
                                    <td> <a href={`/admin/award?award_id=${id}`}><img className="profile_table" src={logo} alt={name}/></a></td>
                                    <td>
                                      <a className="text-decoration-none" href={`/admin/award?award_id=${id}`}>{name}</a>
                                      {admin_privileges ?
                                        null
                                        :
                                        <>
                                          <Row style={{ "fontSize": "14px" }}>
                                            <Col lg="4" className="mt-2">
                                              <BiCategoryAlt className="book_svg_single mr-2" style={{ width: "20px", height: "20px" }} />
                                              {category_count}
                                            </Col>
                                            <Col lg="8" className="mt-2">
                                              <ImHammer2 className="book_svg_single mr-2" style={{ width: "20px", height: "20px" }} />
                                              {judging_status} ({judging_begins ? new Date(judging_begins).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "TBA"} to {judging_deadline ? new Date(judging_deadline).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "TBA"})
                                            </Col>
                                          </Row>
                                          <Row style={{ "fontSize": "14px" }}>
                                            <Col lg="4" className="mt-2">
                                              <BsFillJournalBookmarkFill className="book_svg_single mr-2" style={{ width: "20px", height: "20px" }} />
                                              {booking_count}
                                            </Col>
                                            <Col lg="8" className="mt-2">
                                              <BsListOl className="book_svg_single mr-2" style={{ width: "20px", height: "20px" }} />
                                              {shortlisting_status} ({shortlisting_begins ? new Date(shortlisting_begins).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "TBA"} to {shortlisting_deadline ? new Date(shortlisting_deadline).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "TBA"})
                                            </Col>
                                          </Row>
                                          <Row style={{ "fontSize": "14px" }}>
                                            <Col lg="4" className="mt-2">
                                              <ImEnter className="book_svg_single mr-2" style={{ width: "20px", height: "20px" }} />
                                              {entry_deadline ? new Date(entry_deadline).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "TBA"}
                                            </Col>
                                            <Col lg="8" className="mt-2">
                                              <BsJournalText className="book_svg_single mr-2" style={{ width: "20px", height: "20px" }} />
                                              Booking Status: { booking_status || "Inactive" } 
                                            </Col>
                                          </Row>
                                        </>
                                      }
                                    </td>
                                    <td className="text-right">
                                      <div className="action_table">
                                        <BsThreeDotsVertical />
                                        <Card className="action_content">
                                          <CardBody className="action_container">
                                            <div className="link_container">
                                              <GoDeviceDesktop /> <a href={`/admin/award?award_id=${id}`}>VIEW</a>
                                            </div>
                                            <hr />
                                          </CardBody>
                                        </Card>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                                </>
                              ))}
                            </>
                            :
                            <tr>
                              <td colSpan="6" className="text-center">No records found</td>
                            </tr>
                          }
                        </>
                        :
                        <tr>
                          <td colSpan="6" className="text-center"><div className="table-loading"><PageSpinner /></div></td>
                        </tr>
                      }
                    </thead>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        }
        
      </Container>
      <Modal
        isOpen={addModal}
        className='modal-preview'
        fade={false}
        centered
        id='delete-modal'
      >
        <ModalHeader className='text-uppercase text-left'>
          New Award
          <button type='button' className='close react-modal-close' data-dismiss='modal' aria-label='Close' onClick={() => setAddModal(false)}>
            <span aria-hidden='true'>&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg='12'>
              <Card>
                <CardBody className='card_container'>
                  <Row>
                    <Col lg="12" className="mb-3">
                      <Label><strong>Name</strong><span className='asterisk_red'>*</span></Label>
                      <Input type='text' name="name" value={formData.name} onChange={handleChange} />
                    </Col>
                    <Col lg="12" className="mb-3">
                      <Label><strong>Year</strong><span className='asterisk_red'>*</span></Label>
                      <Input type='number' name="year" value={formData.year} onChange={handleChange} />
                    </Col>
                    <Col lg="12">
                      <Label><strong>Image</strong><span className="asterisk_red">*</span></Label>
                      {imagePreview ?
                        <>
                          <Label
                            onDragEnter={handleDragEnter}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={handleClickFile}
                            className={`${ formStatus === 'loading' ? 'w-100 form-invalid' : 'cursor-pointer w-100' }` }
                            style={formStatus === 'loading' ? { cursor: 'not-allowed', opacity: '0.5'} : {}}
                          >
                            <img src={imagePreview} alt='' className='advertisement-image trophy-image w-100' style={{maxWidth: '200px'}} />
                          </Label>
                          <p className='small text-muted mb-0'>Drag & drop files here or click <span onClick={handleClickFile} className='cursor-pointer advertisement-uploader-helper-text'>here</span> choose files</p>
                          <input
                            type="file"
                            name="logo"
                            ref={hiddenFileInputFile}
                            onChange={handleChange}
                            style={{ display: 'none' }}
                            accept="image/*"
                            required
                          />
                        </>
                        :
                        <div
                          onDragEnter={handleDragEnter}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                          className="bg-transparent w-100 d-flex justify-content-center align-items-center mb-3"
                        >
                          <div className="w-100">
                            <Card className="border-dotted w-100">
                              <CardBody className="d-flex align-items-center justify-content-center">
                                <div
                                  className="project-file-upload"
                                  onClick={handleClickFile}
                                >
                                  <MdOutlineFileUpload size="40px" />
                                  <span>Choose file</span>
                                  <span className="project-fs-12 text-nowrap">
                                    Drag & drop files here or click here choose files
                                  </span>
                                </div>
                              </CardBody>
                            </Card>
                            <input
                              type="file"
                              name="logo"
                              ref={hiddenFileInputFile}
                              onChange={handleChange}
                              style={{ display: 'none' }}
                              accept="image/*"
                              required
                            />
                          </div>
                        </div>
                      }
                    </Col>
                    <Col lg="12">
                      <Label><strong>Sponsors</strong></Label>
                      <Card>
                        <CardBody>
                          <Row>
                            {previousSponsors.length > 0 ?
                              <>
                                {previousSponsors.map(({id, company_name}, index) => (
                                  <Col sm="12" key={index} className="d-flex align-items-center mb-2">
                                    <input 
                                        id={`sponsor_${id}`}
                                        type='checkbox' 
                                        className='cursor-pointer'
                                        onChange={() => handleCheckboxChange(id)}
                                        checked={sponsorIds.includes(id)}
                                    />
                                    &nbsp;&nbsp;
                                    <label className='cursor-pointer mb-0 fw-normal' htmlFor={`sponsor_${id}`}>{company_name}</label>
                                  </Col>
                                ))}
                              </>
                              :
                              <>
                                <Col sm="12" className="text-center">
                                  <span className='project-status-inactive'><i>No records found</i></span>
                                </Col>
                              </>
                            }
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter className='text-right'>
                  <button type='button' className='btn btn-main btn-main-alt mr-2' data-dismiss='modal'
                    onClick={() => setAddModal(false)}>Close
                  </button>
                  {formStatus != 'standby' ?
                    <button className='action-btn btn newbtntheme primary-btn text-white'>Saving...</button>
                    :
                    <button className='action-btn btn newbtntheme primary-btn text-white' onClick={() => submitEvent()}>Save</button>
                  }
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={settingsModal}
        className="modal-preview"
        fade={false}
        centered
      >
        <ModalHeader className="text-uppercase text-left">
          Settings
          <button type="button" className="close react-modal-close" data-dismiss="modal" aria-label="Close" onClick={() => setSettingsModal(false)}>
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="12">
              <Card className="border-top-0">
                <CardBody className='card_container'>
                  <Row>
                    <Col lg="12" className="mb-3">
                      <Label><strong>Name</strong><span className='asterisk_red'>*</span></Label>
                      <Input type='text' name="name" value={settingsFormData.name} onChange={handleChangeSettings} />
                    </Col>
                    <Col lg="12" className="mb-3">
                      <Label><strong>Country</strong><span className='asterisk_red'>*</span></Label>
                      <Input type='select' name="country" value={settingsFormData.country} onChange={handleChangeSettings}>
                        <option value="">Select Country</option>
                        <option value="Ireland">Ireland</option>
                        <option value="United Kingdom">United Kingdom</option>
                      </Input>
                    </Col>
                    <Col className="col-12 mb-3">
                      <Label><strong>SMTP Code</strong></Label>
                      <Input type='text' name="smtp_code" value={settingsFormData.smtp_code} onChange={handleChangeSettings} />
                    </Col>
                  </Row>
                </CardBody> 
                <CardFooter className='text-right'>
                  <button type='button' className='btn btn-main btn-main-alt mr-2' data-dismiss='modal'
                    onClick={() => setSettingsModal(false)}>Close
                  </button>
                  {formStatus != 'standby' ?
                    <button className='action-btn btn newbtntheme primary-btn text-white'>Saving...</button>
                    :
                    <button className='action-btn btn newbtntheme primary-btn text-white' onClick={() => submitAward()}>Save</button>
                  }
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </Page>
  );
}
export default AdminAwardTypePastAwardsPage;